import { swiper, swiperSlide } from 'vue-awesome-swiper';

const GALLERY_FULLSCREEN_OPTIONS = {
	autoplay: false,
	loop: false,
	slidesPerView: 1,
	mousewheelControl: true,
	mousewheel: false,
	pagination: {
		el: '.gal01-gallery-fullscreen__pagination',
		clickable: true
	}
};

export default {
	components: {
		swiper,
		swiperSlide
	},
	props: {
		gallery: {
			required: true,
			type: Object
		},
		activeSlideIndex: {
			required: false,
			type: Number
		}
	},
	data() {
		return {
			currentIndex: 0,
			galleryFullscreen: null,
			galleryFullscreenOptions: GALLERY_FULLSCREEN_OPTIONS,
			sliderPrevButton: null,
			sliderNextButton: null
		}
	},
	mounted() {
		this.initSwipers();
		this.handleSwiperEvents();
		this.setInitialIndex();
	},
	methods: {
		initSwipers() {
			this.galleryFullscreen = this.$refs['gallery-fullscreen'].swiper;
		},
		setInitialIndex() {
			if (this.activeSlideIndex) {
				this.slideToIndex(this.activeSlideIndex, 0);
			}
		},
		toggleGalleryFullscreen() {
			this.$emit('toggle-gallery-fullscreen');
		},
		handleSwiperEvents() {
			this.galleryFullscreen.on('slidePrevTransitionStart', () => {
				this.$emit('set-active-slide-index', this.galleryFullscreen.activeIndex);
			});
			
			this.galleryFullscreen.on('slideNextTransitionStart', () => {
				this.$emit('set-active-slide-index', this.galleryFullscreen.activeIndex);
			});
		},
		slidePrev() {
			this.galleryFullscreen.slidePrev();
		},
		slideNext() {
			this.galleryFullscreen.slideNext();
		},
		slideToIndex(index, transition = 300) {
			this.galleryFullscreen.slideTo(index, transition, true);
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/GAL01-gallery/GAL01-gallery-fullscreen/GAL01-gallery-fullscreen.js